import { render, staticRenderFns } from "./TokenBalances.vue?vue&type=template&id=09b80fc0&"
import script from "./TokenBalances.vue?vue&type=script&lang=js&"
export * from "./TokenBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports